export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/report_paper_icon.aec8b8bc.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};